<template>
    <div class="container">
        <div class="main" style="font-size: 14px;">
            <div class="title" style="text-align:center;font-size: 20px;font-weight: bold">布局西南——DIXCEL中国西南（成都）分仓正式开启！</div>
            <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2024-08-20</div>
            <div style="line-height:30px">
                <div style="text-indent:30px;margin-bottom:20px">继DIXCEL中国华南（佛山）分仓成立之后，DIXCEL中国西南（成都）分仓（西南仓储中心）于近日正式开始运营。</div>
                <div style="text-align:center;font-size: 20px;font-weight: bold">
                    <el-image  style="width:90%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2024_08_20/1.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;margin-bottom:20px">如果说佛山分仓解决了华南地区的“当日送达”、“节省运费”、“现货为王”等课题的话，
                    那么成都分仓的成立将成为DIXCEL开拓西南市场的坚实后盾。</div>

                <div style="text-align:center;font-size: 20px;font-weight: bold">
                    <el-image  style="width:90%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2024_08_20/2.png')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="text-align:center;font-size: 20px;font-weight: bold">
                    <el-image  style="width:90%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2024_08_20/3.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;margin-bottom:20px"> 众所周知，成都乃至整个西南是全国汽车保有量最多的区域，无论是汽车保有量还是消费能力，
                    西南地区将是后市场消费群体中最具发展潜力的地区之一。在经过多次调研以及对成都当地经销商的考察之后，
                    DIXCEL中国最终决定由<span style="font-weight:bold">“成都弘讯汽车用品有限公司”</span>来运营DIXCEL中国西南分仓，DIXCEL中国将与成都弘讯汽车用品有限公司共同开拓、
                    维护西南地区的DIXCEL市场，用更优质的服务回报广大客户的信任。</div>

                <div style="text-align:center;font-size: 20px;font-weight: bold">
                    <el-image  style="width:90%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2024_08_20/4.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-align:center;font-size: 20px;font-weight: bold">
                    <el-image  style="width:90%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2024_08_20/5.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;margin-bottom:20px"> 同时，DIXCEL华北、华中地区的分仓调研工作也正在进行中。
                    不久的将来，“DIXCEL当日达”将成为所有国内经销商、终端客户的标配服务之一，配合“DIXCEL ONLINE经销商采购平台”的联动，
                    经销商能够更快、更优质地服务终端客户，最大程度节省成交成本。</div>

                <div style="text-indent:30px;margin-bottom:20px">未来，你我共进！</div>


            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return{

            }
        }
    }
</script>

<style lang="stylus" scoped>



    .container
        background-color : #000
        .box_one
            width: 100%;

        .box_bottom
            width: 100%;
            background-color #000


    .main {
        margin-bottom: 5px;
        width: 1003px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        padding: 62px 50px 52px;
    }
    .title {
        color :#ab191d;
        text-align:center;
        margin-bottom 10px
    }

</style>
